import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Footer extends Component {
  //Methods
  currentYear = () => {
    const d = new Date();
    return d.getFullYear();
  };

  // JSX Template
  render() {
    return (
      <div className=" grid__full animated fadeInUp">
        <div className="subfooter">
          <ul className="list-unstyled list-inline relax-left  normal-2x fadeInUp">
            <li>
              <Link to="/">© Copyright {this.currentYear()}. Advancly</Link>
            </li>
          </ul>
          <ul className="list-unstyled list-inline relax-right  for-pc normal-2x fadeInUp">
            <li>
              <Link to="/terms-of-use">Terms</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
